module.exports = __webpack_public_path__ + "media/images/main-bg-p-2000-841b58adaf97fe7ff43bd55eccab368d.jpeg";